import type { FaireProductEntity } from "../../entity_types/product";

export const bath_7: FaireProductEntity = {
  token: "bath-7",
  type: "product",
  name: "Jasmine Face Mask",
  brandName: "Pure Soap Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4aa8337171d9d3ec324284e579378ad76d6ddb6e24655db3031f2e985093ac30.webp",
  priceDollars: 16,
  msrpDollars: 26,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_beauty-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
